import { useEffect } from 'react'

const useDfpSlot = (path: string, size: Array<Array<number>>, id: string) => {
    useEffect(() => {
        const div = document.createElement('div')
        div.id = id
        document.body.append(div)

        const googletag = window.googletag || {}
        googletag.cmd = googletag.cmd || []

        if (window.innerWidth >= 1024) {
            googletag.cmd.push(
                function () {
                    googletag.defineSlot(path, size, id).addService(googletag.pubads())
                    googletag.pubads().enableSingleRequest()
                    googletag.enableServices()
                },
                function () {
                    googletag.display(id)
                },
            )
        }
    }, [path, size, id])
}

const useResetSlot = () => {
    useEffect(() => {
        const googletag = window.googletag || {}
        googletag.cmd = googletag.cmd || []
        googletag.cmd.push(function () {
            googletag.pubads().disableInitialLoad()
            googletag.enableServices()
        })
    }, [])
}

export const useYieldLoveIntegration = () => {
    // external scripts
    useEffect(() => {
        // head script
        const scriptYieldLove = document.createElement('script')
        scriptYieldLove.type = 'text/javascript'
        scriptYieldLove.async = true
        scriptYieldLove.src = 'https://cdn-a.yieldlove.com/v2/yieldlove.js?traum-ferienwohnungen.de'
        document.head.append(scriptYieldLove)

        // head script
        const scriptGPT = document.createElement('script')
        scriptGPT.type = 'text/javascript'
        scriptGPT.async = true
        scriptGPT.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
        document.head.append(scriptGPT)
    }, [])

    // head script
    useResetSlot()

    // body script
    useDfpSlot(
        '/53015287,22463734238/traum-ferienwohnungen.de_d_970x90_1',
        [
            [970, 90],
            [728, 90],
        ],
        'div-gpt-ad-1407836034722-0',
    )
}
